import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Avatar, Box, Button, Chevron, Text, Title } from '@factorialco/deprecated-design-system'
import { PeopleChartEmployeeSidepanelBasicInfoFragment } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import EmployeeDetail from './EmployeeDetail'
import TeamsDetail from './TeamsDetail'

type Props = {
  basicInfo: PeopleChartEmployeeSidepanelBasicInfoFragment
  previousEmployeeId?: string
  nextEmployeeId?: string
  onEmployeeSelection: (employeeId: string) => void
  onClose: () => void
  onTeamSelection: (teamId: string, openSidepanel: boolean) => void
  loadingData: boolean
}

const EmployeeSidepanel: FC<Props> = ({
  basicInfo,
  previousEmployeeId,
  nextEmployeeId,
  onClose,
  onEmployeeSelection,
  onTeamSelection,
  loadingData,
}) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const header = (
    <Box alignItems="center" justifyContent="center" flexDirection="row" flexGrow gap="s24">
      {previousEmployeeId !== undefined && (
        <button onClick={() => onEmployeeSelection(previousEmployeeId)}>
          <Chevron type="secondary" direction="left" />
        </button>
      )}
      <Text size="300" color="grey800" weight="semibold">
        {basicInfo.fullName}
      </Text>
      {nextEmployeeId !== undefined && (
        <button onClick={() => onEmployeeSelection(nextEmployeeId)}>
          <Chevron type="secondary" direction="right" />
        </button>
      )}
    </Box>
  )

  const goToProfile = () => {
    navigate(navigation.employees.id.fullPath({ id: basicInfo.id }))
  }

  const footer = (
    <Box paddingY="s16" paddingRight="s8">
      <Button onClick={goToProfile}>{i18n.t('people_chart.go_to_profile')}</Button>
    </Box>
  )

  return (
    <Sidepanel
      open
      title={header}
      width="wide"
      onClose={onClose}
      closeLabel="Close"
      boxPadding={false}
      footer={footer}
    >
      <Box padding="s24">
        <Box
          flexDirection="row"
          padding="s32"
          gap="s24"
          background="grey100"
          borderRadius={{
            all: 'abs016',
          }}
          style={{ marginBottom: '16px' }}
        >
          <Avatar size="s64" label={basicInfo.fullName} url={buildUrl(basicInfo.access?.avatar)} />
          <Box justifyContent="center">
            <Title title={basicInfo.fullName} />
            <Text.Normal weight="semibold" size="200">
              {basicInfo.referenceContract?.jobCatalogLevel?.roleName}
            </Text.Normal>
          </Box>
        </Box>
        <EmployeeDetail employee={basicInfo} />
        <TeamsDetail loading={loadingData} onTeamSelection={onTeamSelection} employee={basicInfo} />
      </Box>
    </Sidepanel>
  )
}

export default EmployeeSidepanel
